stickerMargin = require 'app/scripts/data/sticker-margin'

minValue = -stickerMargin
maxValue = 100 - stickerMargin

# Used to ensure that a sticker is inside the editable area
module.exports = (value) ->
  if value < minValue
    minValue
  else if value > maxValue
    maxValue
  else
    value
